module.exports = __webpack_public_path__ + "img/home_image_mobile.2668978b.png";